
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e7e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e7e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hbluw", function(module, exports) {

$parcel$export(module.exports, "ENDPOINT", function () { return $c82422755965d529$export$1a23c4610ef05bed; });
$parcel$export(module.exports, "UPLOAD_ENDPOINT", function () { return $c82422755965d529$export$cdda3773e71b07e4; });
const $c82422755965d529$var$MODE = "DEV" // 'DEV', 'STAGE', 'PROD'
;
const $c82422755965d529$var$ENVIRONMENTS = {
    PROD: {
        ENDPOINT: "https://hiaudio.fr",
        UPLOAD_ENDPOINT: "https://hiaudio.fr/fileUpload"
    },
    STAGE: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    },
    DEV: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    }
};
const $c82422755965d529$export$1a23c4610ef05bed = $c82422755965d529$var$ENVIRONMENTS[$c82422755965d529$var$MODE].ENDPOINT;
const $c82422755965d529$export$cdda3773e71b07e4 = $c82422755965d529$var$ENVIRONMENTS[$c82422755965d529$var$MODE].UPLOAD_ENDPOINT;

});

parcelRegister("jXEky", function(module, exports) {

$parcel$export(module.exports, "uriUserPage", function () { return $e882cfcc4184df66$export$ff3ad29dbb546598; });
$parcel$export(module.exports, "uriCollectionPage", function () { return $e882cfcc4184df66$export$36dfaec04418caa7; });
$parcel$export(module.exports, "UserRole", function () { return $e882cfcc4184df66$export$eb3485a690c2f0b8; });
$parcel$export(module.exports, "LevelPrivacy", function () { return $e882cfcc4184df66$export$a3c073b335a47d60; });
$parcel$export(module.exports, "PRIVACY_BADGE_STYLE", function () { return $e882cfcc4184df66$export$eba8c17f4d7a3cd3; });
$parcel$export(module.exports, "PRIVACY_BADGE_TEXT", function () { return $e882cfcc4184df66$export$ab4fdfae3dcd1a8f; });
$parcel$export(module.exports, "ROLE_BADGE_STYLE", function () { return $e882cfcc4184df66$export$f25eef55c66a4e9d; });
$parcel$export(module.exports, "startLoader", function () { return $e882cfcc4184df66$export$8afc507ca675ea0e; });
$parcel$export(module.exports, "cancelLoader", function () { return $e882cfcc4184df66$export$81e46b314cb8d8e3; });
$parcel$export(module.exports, "callJsonApi", function () { return $e882cfcc4184df66$export$997d30e836e5c567; });
$parcel$export(module.exports, "looksLikeMail", function () { return $e882cfcc4184df66$export$706cf9fcefe67c8e; });
$parcel$export(module.exports, "activateGoHomeLink", function () { return $e882cfcc4184df66$export$3fc781af82c0c660; });
$parcel$export(module.exports, "MEDIA_CONSTRAINTS", function () { return $e882cfcc4184df66$export$2464c9e69777d386; });

var $hbluw = parcelRequire("hbluw");
const $e882cfcc4184df66$export$ff3ad29dbb546598 = "/index.html?userid=";
const $e882cfcc4184df66$export$36dfaec04418caa7 = "/index.html?collectionid=";
const $e882cfcc4184df66$export$eb3485a690c2f0b8 = Object.freeze({
    none: 0,
    owner: 1,
    admin: 2,
    member: 3,
    guest: 4
});
const $e882cfcc4184df66$export$a3c073b335a47d60 = Object.freeze({
    public: 1,
    onlyreg: 2,
    private: 3
});
const $e882cfcc4184df66$export$eba8c17f4d7a3cd3 = {
    [$e882cfcc4184df66$export$a3c073b335a47d60.public]: "badge-public",
    [$e882cfcc4184df66$export$a3c073b335a47d60.onlyreg]: "badge-onlyreg",
    [$e882cfcc4184df66$export$a3c073b335a47d60.private]: "badge-private"
};
const $e882cfcc4184df66$export$ab4fdfae3dcd1a8f = {
    [$e882cfcc4184df66$export$a3c073b335a47d60.public]: "PUBLIC",
    [$e882cfcc4184df66$export$a3c073b335a47d60.onlyreg]: "REG USERS",
    [$e882cfcc4184df66$export$a3c073b335a47d60.private]: "PRIVATE"
};
const $e882cfcc4184df66$export$f25eef55c66a4e9d = {
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.owner]: "badge-owner",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.admin]: "badge-admin",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.member]: "badge-member",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.guest]: "badge-guest"
};
const $e882cfcc4184df66$export$8afc507ca675ea0e = (loadingMessage)=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;${loadingMessage}`;
    loaderElement.classList.remove("loader-hidden");
};
const $e882cfcc4184df66$export$81e46b314cb8d8e3 = ()=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.classList.add("loader-hidden");
};
const $e882cfcc4184df66$export$997d30e836e5c567 = async (apimethod, rqstmethod, body, useLoaderWithText)=>{
    const request = {
        method: rqstmethod || "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    if (body) request.body = JSON.stringify(body);
    try {
        useLoaderWithText && $e882cfcc4184df66$export$8afc507ca675ea0e(useLoaderWithText);
        const sendRqst = await fetch((0, $hbluw.ENDPOINT) + apimethod, request);
        useLoaderWithText && $e882cfcc4184df66$export$81e46b314cb8d8e3();
        const respToJson = await sendRqst.json();
        if (respToJson && !respToJson.error) return respToJson;
        else return (respToJson === null || respToJson === void 0 ? void 0 : respToJson.error) || "An error occurred";
    } catch (error) {
        useLoaderWithText && $e882cfcc4184df66$export$81e46b314cb8d8e3();
        return error;
    }
};
const $e882cfcc4184df66$export$706cf9fcefe67c8e = (str)=>{
    const lastAtPos = str.lastIndexOf("@");
    const lastDotPos = str.lastIndexOf(".");
    return lastAtPos < lastDotPos && lastAtPos > 0 && str.indexOf("@@") == -1 && lastDotPos > 2 && str.length - lastDotPos > 2;
};
const $e882cfcc4184df66$export$3fc781af82c0c660 = ()=>{
    const goHomeLink = document.getElementById("goHome");
    if (window.location.host === "localhost:80" || window.location.origin === "http://localhost") goHomeLink.href = window.location.origin + "/index.html";
    else goHomeLink.href = window.location.origin;
};
const $e882cfcc4184df66$export$95df08bae54cb4df = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const $e882cfcc4184df66$export$2464c9e69777d386 = {
    audio: {
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false,
        latency: 0,
        channelCount: 1
    }
};

});

parcelRegister("faZmx", function(module, exports) {

$parcel$export(module.exports, "checkIfTermsAccepted", function () { return $b0c76387600d0ed6$export$207bec4913bdffa6; });
$parcel$export(module.exports, "generateAcceptTermsModal", function () { return $b0c76387600d0ed6$export$7ed6abee26b8c64b; });

var $jXEky = parcelRequire("jXEky");
const $b0c76387600d0ed6$export$207bec4913bdffa6 = (userprofile, callback)=>{
    (0, $jXEky.cancelLoader)();
    callback(userprofile === null || userprofile === void 0 ? void 0 : userprofile.terms_accepted);
};
const $b0c76387600d0ed6$export$95d7694256f75341 = ()=>{
    $("#acceptTermsModal").modal({
        backdrop: "static",
        keyboard: false // to prevent closing with Esc button (if you want this too)
    });
    $("#acceptTermsModal").modal("show");
    document.getElementById("buttonAcceptTerms").onclick = $b0c76387600d0ed6$var$rqstAcceptTerms;
    document.getElementById("buttonRejectTerms").onclick = $b0c76387600d0ed6$var$rqstRejectTerms;
};
const $b0c76387600d0ed6$var$rqstAcceptTerms = async ()=>{
    const data = await (0, $jXEky.callJsonApi)("/acceptterms", "PUT", null, "Welcome...");
    if (data.ok) $("#acceptTermsModal").modal("hide");
};
const $b0c76387600d0ed6$var$rqstRejectTerms = async ()=>{
    const data = await (0, $jXEky.callJsonApi)("/rejectterms", "PUT", null, "Deleting information...");
    if (data.ok) {
        $("#acceptTermsModal").modal("hide");
        window.location.href = window.location.origin;
    }
};
const $b0c76387600d0ed6$export$7ed6abee26b8c64b = (attachToElem)=>{
    const isModal = document.getElementById("acceptTermsModal");
    if (!isModal) {
        const modalDialog = `<div class="modal fade" id="acceptTermsModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title">Accept Terms</h5>                
                </div>
                <div class="modal-body">
                <p>By clicking on OK you accept the Terms of Use.</p>
                <p>More information at: <span> <a href="${window.location.origin}/static/terms.html" target="_blank">${window.location.origin}/static/terms.html</a></span></p>
                </div>
                <div class="modal-footer">
                <button id="buttonRejectTerms" type="button" class="btn btn-secondary" data-dismiss="modal">Reject</button>
                <button id="buttonAcceptTerms" type="button" class="btn btn-primary">OK</button>
                </div>
            </div>
            </div>
        </div>`;
        document.getElementsByTagName(attachToElem)[0].insertAdjacentHTML("afterend", modalDialog);
    }
    $b0c76387600d0ed6$export$95d7694256f75341();
};

});

/* TODO: REFACTORING */ 
var $hbluw = parcelRequire("hbluw");

var $jXEky = parcelRequire("jXEky");

var $faZmx = parcelRequire("faZmx");
let $df4cee02edea8f55$var$CURRENT_USERNAME = null;
let $df4cee02edea8f55$var$EDIT_STATUS = false;
const $df4cee02edea8f55$var$editUserNameButton = document.getElementById("editusernamebutton");
const $df4cee02edea8f55$var$profilePageTermsAccepted = (termsAccepted)=>{
    if (!termsAccepted) (0, $faZmx.generateAcceptTermsModal)("main");
};
const $df4cee02edea8f55$var$getUser = async (callback)=>{
    const data = await (0, $jXEky.callJsonApi)("/profile", "GET");
    if (data) callback(data);
};
const $df4cee02edea8f55$var$setUserInfo = (userinfo)=>{
    if (userinfo.ok) {
        (0, $faZmx.checkIfTermsAccepted)(userinfo, $df4cee02edea8f55$var$profilePageTermsAccepted);
        document.getElementById("profilecard").hidden = false;
        document.getElementById("profilepicture").src = `https://picsum.photos/seed/${userinfo.user_uid}/200`;
        $df4cee02edea8f55$var$CURRENT_USERNAME = userinfo.name;
        document.getElementById("usernameinputfield").value = userinfo.name;
        document.getElementById("userid").innerHTML = userinfo.user_uid;
        document.getElementById("emailaddress").innerHTML = userinfo.email;
        $df4cee02edea8f55$var$deleteProfileHandler(userinfo.user_uid);
        document.getElementById("apicard").hidden = false;
        document.getElementById("apitoken").innerHTML = userinfo.token;
        document.getElementById("curlcode").innerHTML = `$ export JWT="${userinfo.token}"  <br /><br />$ curl ${window.location.protocol}//${window.location.host}/profile   -H "Authorization: Bearer $JWT"`;
        $df4cee02edea8f55$var$copyPasteTokenValue();
    } else document.getElementById("logincard").hidden = false;
};
const $df4cee02edea8f55$var$deleteProfileHandler = (userid)=>{
    document.getElementById("button-deleteprofile").addEventListener("click", async ()=>{
        await $df4cee02edea8f55$var$deleteUserProfile(userid);
    });
};
const $df4cee02edea8f55$var$copyPasteTokenValue = ()=>{
    document.getElementById("copytokenbutton").onclick = ()=>{
        window.prompt("Copy to clipboard: Ctrl+C, Enter", document.getElementById("apitoken").innerHTML);
    };
};
const $df4cee02edea8f55$var$deleteUserProfile = async (userid)=>{
    const api = "/deleteuser/" + userid;
    let userDelete = prompt("To confirm, please enter your User ID", "");
    if (userDelete === userid) {
        const request = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        try {
            const sendRqst = await fetch((0, $hbluw.ENDPOINT) + api, request);
            const respToJson = await sendRqst.json();
            if (respToJson) window.location.href = window.location.origin;
        } catch (error) {
            alert(error);
        }
    } else if (userDelete !== userid && userDelete !== null) alert("Sorry, the User ID does not match");
};
const $df4cee02edea8f55$var$clickEditButtonHandler = ()=>{
    if ($df4cee02edea8f55$var$EDIT_STATUS) $df4cee02edea8f55$var$disableEdition();
    else {
        $df4cee02edea8f55$var$EDIT_STATUS = true;
        $df4cee02edea8f55$var$editUserNameButton.innerHTML = '<i class="fas fa-save">&nbsp;</i>Save';
        $df4cee02edea8f55$var$enableEdition();
    }
};
const $df4cee02edea8f55$var$enableEdition = ()=>{
    document.getElementById("usernameinputfield").classList.add("italic");
    document.getElementById("usernameinputfield").removeAttribute("readonly");
};
const $df4cee02edea8f55$var$disableEdition = async ()=>{
    const usernameinput = document.getElementById("usernameinputfield");
    const newname = usernameinput.value;
    usernameinput.value = newname.trim();
    if ($df4cee02edea8f55$var$CURRENT_USERNAME === newname) $df4cee02edea8f55$var$setBackToReadOnly();
    else {
        const body = {
            user_name: newname
        };
        const resultNewName = await (0, $jXEky.callJsonApi)("/updateusername", "PATCH", body, "Updating user...");
        if (!resultNewName.ok) {
            usernameinput.classList.add("is-invalid");
            document.getElementById("validationusernameresult").innerText = "Sorry, " + resultNewName;
        } else {
            $df4cee02edea8f55$var$CURRENT_USERNAME = newname;
            $df4cee02edea8f55$var$setBackToReadOnly();
        }
    }
};
const $df4cee02edea8f55$var$setBackToReadOnly = ()=>{
    const usernameinput = document.getElementById("usernameinputfield");
    $df4cee02edea8f55$var$EDIT_STATUS = false;
    $df4cee02edea8f55$var$editUserNameButton.innerHTML = '<i class="fas fa-edit">&nbsp;</i>Edit username';
    usernameinput.setAttribute("readonly", "true");
    usernameinput.classList.remove("is-invalid");
    usernameinput.classList.remove("italic");
    document.getElementById("validationusernameresult").innerText = "";
};
(0, $jXEky.activateGoHomeLink)();
$df4cee02edea8f55$var$editUserNameButton.addEventListener("click", $df4cee02edea8f55$var$clickEditButtonHandler, false);
$df4cee02edea8f55$var$getUser($df4cee02edea8f55$var$setUserInfo);


//# sourceMappingURL=profile.1b306a96.js.map
